import { CLICK_ACTIONS, IMPRESSION_ACTIONS, SCREEN_NAME } from "@payment-client/analytics/constants";
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

export const mwebUpiIntentRedirectFailureImpressionEvent = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    context: Record<string, string | number | undefined>,
): void => {
    impressionEvent({
        category: SCREEN_NAME.PAYMENT,
        action: IMPRESSION_ACTIONS.IMPRESSION_MWEB_UPI_INTENT_REDIRECT_FAILURE,
        context: JSON.stringify(context),
    });
};

export const upiIntentBackClickEvent = (clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.UPI_INTENT_POLLER,
        action: CLICK_ACTIONS.CLICK_UPI_INTENT_BACK,
    });
};

export const upiIntentCancelHalfCardCancelClickEvent = (clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.UPI_INTENT_POLLER,
        action: CLICK_ACTIONS.CLICK_UPI_INTENT_CANCEL,
    });
};

export const upiIntentImpressionEvent = (impressionEvent: AnalyticsContextValue["impressionEvent"]): void => {
    impressionEvent({
        category: SCREEN_NAME.UPI_INTENT_POLLER,
        action: IMPRESSION_ACTIONS.IMPRESSION_UPI_INTENT,
    });
};
